var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from '@max/max';
import { RequestStatus, requestDataCenter } from '../utils/request';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export function useRequest() {
    const [response, setResponse] = useState(null);
    const ctx = useMonitorEngineContext();
    const [requestStatus, setRequestStatus] = useState(RequestStatus.LOADING);
    const request = (options) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const { onSuccess, onError, onFinally, requestConfig } = options;
        try {
            setRequestStatus(RequestStatus.LOADING);
            const response = yield requestDataCenter(requestConfig);
            // 保存响应数据
            setResponse(response);
            setRequestStatus(RequestStatus.SUCCESS);
            (_b = (_a = ctx._raptorReport).monitorReportNetworkSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                apiPath: requestConfig.path
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
        }
        catch (err) {
            (_d = (_c = ctx._raptorReport).monitorReportNetworkFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                apiPath: requestConfig.path
            });
            const error = err;
            setRequestStatus(RequestStatus.ERROR);
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
        finally {
            onFinally === null || onFinally === void 0 ? void 0 : onFinally();
        }
    });
    return {
        response,
        requestStatus,
        request,
        setResponse,
        isLoading: requestStatus === RequestStatus.LOADING,
        isSuccess: requestStatus === RequestStatus.SUCCESS,
        isError: requestStatus === RequestStatus.ERROR
    };
}
